import { render, staticRenderFns } from "./reasonDescription.vue?vue&type=template&id=5f120c92&scoped=true&"
import script from "./reasonDescription.vue?vue&type=script&lang=js&"
export * from "./reasonDescription.vue?vue&type=script&lang=js&"
import style0 from "./reasonDescription.vue?vue&type=style&index=0&id=5f120c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f120c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f120c92')) {
      api.createRecord('5f120c92', component.options)
    } else {
      api.reload('5f120c92', component.options)
    }
    module.hot.accept("./reasonDescription.vue?vue&type=template&id=5f120c92&scoped=true&", function () {
      api.rerender('5f120c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usergroup/validation/reasonDescription.vue"
export default component.exports